module.exports = __webpack_public_path__ + "static/img/diyim1.ed381ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyim1.png
// module id = dfcS
// module chunks = 5